import api from './api';
import { FacilityCode } from '@gff/shared';

export interface IFacilityItemTelemetry {
  ingredientId: string;
  ingredientCode: string;
  displayName: string;
  unit: string;
  onHand: number;
  allocated: number;
  lowStockThreshold: number;
  reorderQuantity: number;
  dailyBurnRate14d: number;
  daysOfSupply: number;
  severity: 'NORMAL' | 'LOW_STOCK' | 'CRITICAL_DEPLETION';
}

export interface IFacilitySummaryTelemetry {
  facility: FacilityCode;
  totalSkus: number;
  totalOnHandUnits: number;
  totalAlertsCount: number;
  averageDaysOfSupply: number;
  items: IFacilityItemTelemetry[];
}

export interface IGlobalTelemetryMatrix {
  timestamp: string;
  facilities: Record<FacilityCode, IFacilitySummaryTelemetry>;
  consolidated: {
    totalSkus: number;
    totalAlertsCount: number;
    criticalCount: number;
  };
}

export const fetchGlobalTelemetryMatrix = async (): Promise<IGlobalTelemetryMatrix> => {
  const response = await api.get('/inventory/telemetry/global');
  return response.data?.data;
};

export const fetchFacilityTelemetry = async (facility: FacilityCode): Promise<IFacilitySummaryTelemetry> => {
  const response = await api.get(`/inventory/telemetry/facility/${facility}`);
  return response.data?.data;
};
